import React from 'react';
import FadeIn from './ui/FadeIn';

export default function TargetAudience() {
  return (
    <section className="py-24 bg-sage text-white text-center">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6">Built for the Floral Industry</h2>
          <p className="text-lg md:text-xl font-light leading-relaxed text-sage-100 opacity-90">
            For florists, flower shops, event designers, and studio owners who want beautiful branded vases without the custom minimum headaches. Whether you need 4 or 40, we've got you.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}